import { toRaw } from "vue";

export const mapAttribute = ({ props }) => {
    const masterAttribute = props.masterAttribute || [];
    const attribute = props.record.attribute || [];
    return attribute.map(attr => masterAttribute.find(d => d.key === attr)).filter(attr => attr);
};

export const onSelect = ({ props, value }) => {
    const record = toRaw(props.record); // mark for don't rerender AttributeSelect
    record.isSave = true;
    if (!record.attribute) {
        record.attribute = [];
    }
    record.attribute.push(value.key);
};

export const onDeselect = ({ props, value }) => {
    const record = toRaw(props.record); // mark for don't rerender AttributeSelect
    record.isSave = true;
    record.attribute = record.attribute.filter(attr => attr !== value.key);
};

export const crossCheck = ({ props }) => {
    const record = toRaw(props.record);
    record.isSave = true;
    const masterAttribute = props.masterAttribute || [];
    record.attribute = record.attribute?.filter(attr => masterAttribute.find(d => d.key === attr)) || [];
};
